var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-footer"},[_c('div',[_c('img',{attrs:{"src":require('@/assets/img/footer_des.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }